import { IPublicClientApplication } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import { loginRequest } from "../../authConfig";
import logo from "../../images/logo-square.png";
import train from "../../images/train.jpg";

function handleLogin(instance: IPublicClientApplication) {
    instance.loginRedirect(loginRequest).catch((e: any) => {
        console.error(e);
    });   
}

export const SignInButton = () => {
    const { instance } = useMsal();

    return (
        <Button variant="contained" color="primary" sx={{ width: "20%" }} onClick={() => handleLogin(instance)}>Sign in</Button>
    );
}

const FullpageContainer = styled('div')(() => ({

    height: "100%",
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: "url(" + train + ")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    paddingBottom: "30rem"
}));

export const SignIn = () => {

    return (
        <FullpageContainer>
            <img src={logo} alt="Porterbook"/>
            <Typography variant="h3" sx={{
                marginBottom: "1rem",
                marginTop: "1rem",
                fontWeight: "bold"
            }}>
                Welcome to Portbrook SIMS
            </Typography>
            <SignInButton />
        </FullpageContainer>
    );
}